/**
* Created by bieao on 2020/4/1.
*/
<template>
  <div class="item-position header">
    <div class="splitLine-top"></div>
    <div class="header-content">
      <div class="logo-item" v-if="!!logo">
        <img
          :src='`https://static-resources-1255452421.cos.ap-beijing.myqcloud.com/img/${logo}-datav-logo.png`'
          @error="loadImgError"
          alt=""/>
      </div>
      <div class="header-name">
        <div v-if="logo !== 'bjcj'" class="project-name">{{projectInfo.name}}</div>
        <div class="project-status">
          <div/>
          <div>施工中</div>
          <div class="time-item m-l-30 m-r-30">{{time}}</div>
        </div>
      </div>
    </div>
    <div class="splitLine-bottom" ></div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
const dateFormat = 'YYYY-MM-DD HH:mm:ss'
export default {
  name: 'Header',
  data () {
    return {
      time: dayjs().format(dateFormat)
    }
  },
  props: {
    projectInfo: {
      type: Object
    },
    logo: {
      type: String
    }
  },
  computed: {},
  methods: {
    showTime () {
      setInterval(() => {
        this.time = dayjs().format(dateFormat)
      }, 1000)
    },
    loadImgError () {
      this.$emit('changeLogo')
    }
  },
  created () {
    this.showTime()
  }
}
</script>

<style scoped lang="scss">
  .header {
    left:0;
    top:20px;
    .splitLine-top{
      width:1800px;
      height:2px;
      background-size: 100% 100%;
      background: url("/static/img/splitLine4.png") no-repeat;
      filter: blur(1px);
    }
    .splitLine-bottom{
      width:1400px;
      height:2px;
      background-size: 100% 100%;
      background: url("/static/img/splitLine4.png") no-repeat;
      filter: blur(1px);
    }
    .header-content {
      display: flex;
      align-items: center;
      height: 100px;
      padding: 10px 0 10px 20px;
      .logo-item{
        height: 100%;
        min-width: 150px;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          height: 100%
        }
      }
      .header-name {
        display: flex;
        flex-direction: column;
        margin-left: 30px;
        .project-name{
          font-size: 35px;
          font-weight: 500;
        }
        .project-status{
          font-size: 14px;
          font-weight: 600;
          display: flex;
          align-items: center;
          & > div:first-child{
            width: 15px;
            height:15px;
            background-size: 100% 100% !important;
            margin-right: 10px;
            color:#5f7f9b;
            background: url('/static/img/shigong.png') center center no-repeat;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue